import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import {gql} from "@irati/utils/gql"

const query = gql`
  query MFAGetUser($userId: ID) {
    mfaGetUser(userId: $userId) {
      userId
      phoneNumber
      phoneNumberLastDigits
      isConfirmed
      createdAt
    }
  }
`
export const mfaGetUserKey = getQueryNames(query)[0]

export default query
